import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import {
  AUTH_MANAGER,
  logoutUser,
  selectIsAuthenticated,
  selectUserSession
} from '@asset-solutions/customer-portal/auth/data-access';
import { CustomerSelectComponent } from '@asset-solutions/customer-portal/auth/feature-main';
import { CUSTOMER_PORTAL_CONFIG, FIREBASE_APP } from '@asset-solutions/customer-portal/config';
import { ContactUsComponent } from '@asset-solutions/customer-portal/contact-us';
import { SideDrawerComponent, SideDrawerContentDirective } from '@asset-solutions/customer-portal/shared/ui';
import { LoadingComponent } from '@asset-solutions/shared/http';
import { AlertBannerComponent, ColorMode } from '@asset-solutions/shared/ui';
import { Store } from '@ngrx/store';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { filter } from 'rxjs';

import { AccountManagerComponent } from './account-manager/account-manager.component';
import { NavigationComponent } from './navigation/navigation.component';
import { UserMenuComponent } from './user-menu/user-menu.component';

@Component({
  imports: [
    RouterOutlet,
    MatToolbar,
    NavigationComponent,
    LoadingComponent,
    CustomerSelectComponent,
    SideDrawerComponent,
    SideDrawerContentDirective,
    ContactUsComponent,
    UserMenuComponent,
    AccountManagerComponent,
    AlertBannerComponent
  ],
  selector: 'cp-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly authManager = inject(AUTH_MANAGER);
  private readonly config = inject(CUSTOMER_PORTAL_CONFIG);
  private readonly firebaseApp = inject(FIREBASE_APP);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  protected readonly colorMode = inject(ColorMode);

  protected alerts = this.config.alerts;
  protected showContactUs = signal(false);
  protected user = computed(() => {
    const isAuthenticated = this.store.selectSignal(selectIsAuthenticated);
    const user = this.authManager.currentUser();
    return isAuthenticated() ? user : null;
  });
  protected userSession = this.store.selectSignal(selectUserSession);

  public ngOnInit(): void {
    if (this.config.enableAnalytics) {
      const analytics = getAnalytics(this.firebaseApp);
      this.router.events
        .pipe(filter((event: any) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          logEvent(analytics, 'page_view', { page_location: event.urlAfterRedirects });
        });
    }
  }

  protected logout(): void {
    this.store.dispatch(logoutUser());
  }

  protected navigateToPasswordReset(): void {
    this.router.navigate(['/change-password']);
  }
}
